import { getDateRange } from "./datetime"

export const generateFilter = (filters) =>
  filters
    .filter((f) => f.value !== "All")
    .map((f) => {
      if (
        f.id === "createdAt" ||
        f.id === "CreatedAt" ||
        f.id === "LastUpdatedAt"
      ) {
        const interval = getDateRange(f.value)
        return {
          id: f.id,
          value: [interval.start.toISO(), interval.end.toISO()].join(","),
        }
      }
      if (f.id === "LogType") {
        const extractedLogType = getLogTypeBasedOnValue(f.value)
        return {
          id: f.id,
          value: extractedLogType,
        }
      }
      return { id: f.id, value: f.value.toLowerCase().trim() }
    })
    .reduce((acc, f) => {
      acc[f.id] = f.value
      return acc
    }, {})

export const getLogTypeBasedOnValue = (value) => {
  if (value === "Invalid XHTML") {
    return "ERROR_INVALID_XHTML"
  } else if (value === "Non Spine/Herniation Info Missing") {
    return "INFO_NON_CSP_LSP_REPORT"
  } else {
    return ""
  }
}

export const stringToBoolean = (str) => {
  if (typeof str === "string") {
    return str === "true"
  }

  return str
}
